<template>
  <div style="min-height: 92vh">
    <div>
      <ModuleHeader>Documentos de Transferencia de mercancias</ModuleHeader>
      <v-card class="mb-5" flat>
        Filtrar por fecha
        <v-card-text class="ma-1">
          <v-row>
            <v-col md="5" cols="12">
              <label>Fecha inicial</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDate(date, 1)"
                :value="input_date.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="5" cols="12">
              <label>Fecha final</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDateFinal(date, 1)"
                :disabled-dates="disableDates"
                :value="input_date_final.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="2" cols="12" class="text-center align-content-center">
              <v-btn color="success" @click="getDocuments()"> Buscar </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <v-btn v-show="false" color="green" dark>
      <v-icon>mdi-file-excel-box</v-icon>
      <download-excel
        ref="btnExcel"
        type="xls"
        name="Transferencias"
        :data="excelData"
      >
        Exportar a Excel
      </download-excel>
    </v-btn>

    <Modal
      v-model="showCreator"
      titulo="Documento de Transferencia"
      @toggle="showCreator = $event"
      :fullscreen="true"
    >
      <DocumentosTransferCreator
        :key="editingId"
        :idDocumento="editingId"
        :depto-origen="$route.query.deptoOrigen"
        :almacen-origen="$route.query.almacenOrigen"
        :depto-destino="$route.query.deptoDestino"
        :almacen-destino="$route.query.almacenDestino"
        @close="showCreator = false"
      />
    </Modal>
  </div>
</template>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>

<script>
import moment from "moment";
import uvDataTable from "../../MainComponents/DataTable.vue";
import Datepicker from "vuejs-datepicker";
import modal from "../../MainComponents/modal.vue";
import DocumentosTransferCreator from "./DocumentosTransferCreator.vue";

export default {
  name: "DocumentosCRUD",
  components: {
    uvDataTable,
    Datepicker,
    modal,
    DocumentosTransferCreator,
  },
  props: [],
  data() {
    return {
      showCreator: false,
      editingId: null,
     

      input_date: moment(),
      input_date_final: moment(),
      excelData: [],

      origenes: [],
      Documentos: [],
      formIndex: 0,
      editMode: false,
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva Transferencia de Mercancias",
            icon: "lni lni-clipboard",
            buttonId: "addDocumentRecepcion",
          },
          {
            text: "Abrir documento",
            icon: "lni lni-pencil-alt",
            buttonId: "editDocumentRecepcion",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentRecepcion",
            require: true,
          },
          {
            text: "Copiar origen y destino",
            icon: "lni lni-clipboard",
            buttonId: "origenDestino",
            require: true,
          },
          {
            text: "Exportar excel",
            icon: "lni lni-download",
            buttonId: "exportExcel",
            require: false,
          },
        ],
        fields: [
          {
            text: "Documento de mercancias",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
            format: (row) => {
              return (
                "<b>" +
                row["Fecha"] +
                "</b><br/>" +
                '<b style="color:green;">' +
                row["CreadoPor"] +
                "</b>"
              );
            },
          },
          {
            text: "Ultima actualización",
            value: "FechaUpa",
            format: (row) => {
              return (
                "<b>" +
                row["FechaUpa"] +
                "</b><br/>" +
                '<b style="color:green;">' +
                row["ActualizadoPor"] +
                "</b>"
              );
            },
          },
          {
            text: "Departamento",
            value: "Departamento",
            canBeFiltered: true,
          },

          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["Status"] == "Completado") {
                return '<b style="color:green;">' + row["Status"] + "</b>";
              } else {
                return '<b style="color:orange;">' + row["Status"] + "</b>";
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    async dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addDocumentRecepcion") {
        /* this.createDocument();
        this.$router.push({
          path: "/productos-inventarios/documentoTransferencia",
        });
        const routeData = this.$router.resolve({ path: "/productos-inventarios/documentoTransferencia/" + idSelected});
        window.open(routeData.href, '_blank');*/

        this.editingId = null;
        this.showCreator = true;
      }
      if (buttonId == "editDocumentRecepcion") {
        /* const routeData = this.$router.resolve({ path: "/productos-inventarios/documentoTransferencia/" + idSelected});
        window.open(routeData.href, '_blank');
        this.$router.push({
          path: "/productos-inventarios/documentoTransferencia/" + idSelected,
        });*/
        this.editingId = idSelected[0];
        this.showCreator = true;
      }

      if (buttonId == "deleteDocumentRecepcion") {
        this.deleteDoc(idSelected[0]);
      }

      if (buttonId == "origenDestino") {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        const doc = firestore.doc(
          "AMC_TransferenciasInventario/",
          idSelected[0]
        );
        const data = await firestore.getDoc(doc);
        let document = { id: data.ref.id, ...data.data() };
        const origin = window.location.origin;
        const base = this.$route.path; 
        const copyText =
          origin +
          base +
          "?deptoOrigen=" +
          document.from.dpt +
          "&almacenOrigen=" +
          document.from.amc +
          "&deptoDestino=" +
          document.to.dpt +
          "&almacenDestino=" +
          document.to.amc;
        navigator.clipboard.writeText(copyText);
        this.$swal(
          "Copiado al portapapeles",
          "Es posible pegar el link en otra pestaña",
          "success"
        );
        // console.log(copyText);
        // console.log(document);
      }

      if (buttonId == "exportExcel") {
        this.processExcel();
      }
    },

    async processExcel() {
      const dataExcel = [];

      this.Documentos.forEach((doc) => {
        if (doc.items) {
          Object.entries(doc.items).forEach(([itemId, item]) => {
            dataExcel.push({
              Transferencia: doc.Nombre,
              "Documento ID": doc.id,
              origenId: doc.origenId,
              origenNombre: doc.origenNombre,
              Fecha: doc.Fecha,
              FechaUpa: doc.FechaUpa,
              ActualizadoPor: doc.ActualizadoPor,
              CreadoPor: doc.CreadoPor,
              Departamento: doc.Departamento,
              stc: doc.stc,
              Status: doc.Status,
              "Item ID": itemId,
              "Item Nombre": item.nm,
              Activo: item._e ? "Sí" : "No",
              Cantidad: item.cn,
            });
          });
        }
      });

      this.excelData = dataExcel;

      try {
        const dataProcesada = await this.$refs.btnExcel.getProcessedJson(
          dataExcel
        );
        this.$refs.btnExcel.export(
          this.$refs.btnExcel.jsonToXLS(dataProcesada),
          `TRANSFERENCIAS ${this.input_date} - ${this.input_date_final}`,
          "application/vnd.ms-excel"
        );
      } catch (error) {
        console.error("Error al exportar a Excel:", error);
      }
    },

    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },

    toggleModal(open) {
      this.showCreator = open;
    },

    async deleteDoc(id) {
      let docu = this.getDocuById(id);
      if (docu.Aplicado) {
        this.$swal(
          "No puedes eliminar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas el documento de entrada de mercancias?",
        text: "Al eliminarlo se perderan todos los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-eliminarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_TRASPASO_DELETE",
              Mensaje: `Documento de traspaso eliminado: ${datos.Id}`,
              reference: { id: datos.Id, tp: "INV-TraspasoMercancia", al: "TRASPASO INVENTARIO" },
              data: docu || datos
            });
            this.$swal(
              "Documento se elimino correctamente",
              "El documento se elimino correctamente",
              "success"
            );
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },

    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = this.input_date;
    },

    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },

    async getDocuments() {
      try {
        const fechaInicio = moment(
          this.input_date.format("YYYY-MM-DD") + " 00:00"
        ).valueOf();
        const fechaFin = moment(this.input_date_final).endOf("day").valueOf();

        this.Documentos = [];
        const firestore = this.$store.getters.getFirebaseApp.firestore;

        const data = await firestore.queryBuilder(
          "AMC_TransferenciasInventario",
          [
            firestore.where(
              "tenant",
              "==",
              this.$store.getters.getFirebaseApp.tenant
            ),
            firestore.where("mta.cra.t", ">=", fechaInicio),
            firestore.where("mta.cra.t", "<=", fechaFin),
          ]
        );

        let document = data.docs.map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        });

        document.forEach((data) => {
          let fecha = data.mta?.cra?.t ? new moment(data.mta.cra.t) : null;
          let fechaUpa = data.mta?.upa?.t ? new moment(data.mta.upa.t) : null;
          let updatedBy = data.mta?.upa?.u?.n || "";
          let createdBy = data.mta?.cra?.u?.n || "";

          let origenData = this.getOrigenById(data.from?.amc || "");
          this.Documentos.push({
            items: data.cto,
            id: data.id,
            origenId: data.from.amc,
            origenNombre: origenData?.Nombre || "Desconocido",
            Nombre: "Transferencia - " + data.id,
            Fecha: fecha ? fecha.format("YYYY-MM-DD HH:mm") : "",
            FechaUpa: fechaUpa ? fechaUpa.format("YYYY-MM-DD HH:mm") : "",
            ActualizadoPor: updatedBy,
            CreadoPor: createdBy,
            Departamento: data.from.dpt,
            stc: data.sts,
            Status: data.sts == "A" ? "Completado" : "Pendiente",
          });
        });

        this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
      } catch (error) {
        console.error("Error: ", error);
      }
    },

    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
      this.getDocuments();
    },

    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    disableDates() {
      return { to: moment(this.input_date).toDate() };
    },
  },
  watch: {},
  mounted() {},
  async created() {
    if (
      this.$route.query.deptoOrigen &&
      this.$route.query.almacenOrigen &&
      this.$route.query.deptoDestino &&
      this.$route.query.almacenDestino
    ) {
      this.editingId = null;
      this.showCreator = true;
    }
    await this.getOrigenes();
  },
};
</script>
